if (typeof PickupAvailability !== 'function') {
	class PickupAvailability extends HTMLElement {
		constructor() {
			super();

			if (!this.hasAttribute('available')) return;

			this.selectors = {
				pickupAvailabilityPreview: 'pickup-availability-preview',
				button: 'button',
				drawer: 'drawer-component[data-type="drawer"]',
				iconContainer: '.pickup-availability-info__icon',
				info: '.pickup-availability-info',
			};

			this.elements = {
				button: this.querySelector(this.selectors.button),
				drawer: document.querySelector(this.selectors.drawer),
				iconContainer: this.querySelector(this.selectors.iconContainer),
				info: this.querySelector(this.selectors.info),
			};

			this.icon = this.dataset.icon;
			this.colorScheme = this.dataset.colorScheme;
			this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
			this.onClickRefreshList = this.onClickRefreshList.bind(this);

			this.fetchAvailability(this.dataset.variantId);
		}

		fetchAvailability(variantId) {
			let rootUrl = this.dataset.rootUrl;

			if (!rootUrl.endsWith('/')) {
				rootUrl += '/';
			}

			const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
			fetch(variantSectionUrl)
				.then((response) => response.text())
				.then((text) => this.handleFetchSuccess(text))
				.catch((error) => this.handleFetchError(error));
		}

		handleFetchSuccess(text) {
			const sectionInnerHTML = new DOMParser()
				.parseFromString(text, 'text/html')
				.querySelector('.shopify-section');

			this.responseContent = sectionInnerHTML.querySelector('.pickup-availability');
			this.renderPreview(sectionInnerHTML);
		}

		handleFetchError(error) {
			const button = this.querySelector('button');

			if (button) {
				button.removeEventListener('click', this.onClickRefreshList);
			}

			this.renderError();
		}

		onClickRefreshList(evt) {
			this.fetchAvailability(this.dataset.variantId);
		}

		renderError() {
			this.innerHTML = '';
			const button = this.querySelector('button');

			if (button) {
				button.addEventListener('click', this.onClickRefreshList);
			}
		}

		renderPreview(sectionInnerHTML) {
			const { drawer, colorScheme } = this;

			if (!sectionInnerHTML.querySelector(this.selectors.pickupAvailabilityPreview)) {
				this.innerHTML = '';
				this.removeAttribute('available');
				return;
			}

			this.innerHTML = '';
			this.iconContainer = sectionInnerHTML
				.querySelector(this.selectors.pickupAvailabilityPreview)
				.querySelector(this.selectors.iconContainer);

			if (this.iconContainer) {
				this.iconContainer.innerHTML = this.icon;
			}

			const info = sectionInnerHTML.querySelector(this.selectors.info);

			if (info) {
				info.classList.add(colorScheme);
			}

			this.insertAdjacentHTML(
				'beforeend',
				sectionInnerHTML.querySelector(this.selectors.pickupAvailabilityPreview).outerHTML
			);

			this.setAttribute('available', '');

			const button = this.querySelector('button');

			if (button) {
				button.addEventListener('click', (evt) => {
					this.elements.drawer.replaceDrawerHeading(window.variantStrings.pickup_availability_title_drawer);
					this.elements.drawer.replaceDrawerContent(this.responseContent.innerHTML);
					this.elements.drawer.openDrawer('drawer');
				});
			}
		}
	}

	if (!customElements.get('pickup-availability')) {
		customElements.define('pickup-availability', PickupAvailability);
	}
}
